module.exports = __webpack_public_path__ + "static/media/ChangeFlexiCardPin.1d304760.png";